<template>
  <div data-whycatcher-deploy="app-s3-smoke-1">
    <OffCanvasRoot />
    <!-- Markup shared across all pages, ex: NavBar -->
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </div>
</template>